<template>
  <div class="bg-white">
    <div class="lg:py-32 md:py-24 py-20 relative">
      <div class="absolute bg-design1 mob-hidden">
        <img
          src="@/assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img src="@/assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design3 mob-hidden">
        <img
          src="@/assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bottom-44 right-0 absolute md:hidden lg:block mob-hidden">
        <img
          src="@/assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <CartDetails />
    </div>
  </div>
</template>
<script>
import CartDetails from "./components/CartDetails.vue";
export default {
  components: {
    CartDetails,
  },
  metaInfo: {
    title: "Caregiver Sathi - online courses - My Cart",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content: "Complete purchase of your courses and step-up your learning.",
      },
    ],
  },
};
</script>
